import { render, staticRenderFns } from "./FavoriteModal.vue?vue&type=template&id=6033aaec&scoped=true"
import script from "./FavoriteModal.vue?vue&type=script&lang=js"
export * from "./FavoriteModal.vue?vue&type=script&lang=js"
import style0 from "./FavoriteModal.vue?vue&type=style&index=0&id=6033aaec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6033aaec",
  null
  
)

export default component.exports